import { FormControlDependsOnSchema, FormControlDependsOnThenEnum } from "@generation/core";
import { DependsOnThenEnum } from "../client/enums/dependsOnThenEnum";
import { IDependsOn, INestedDependsOn } from "../client/model/dependsOn";
import { SetValueDependsOnMapper } from "./DependsOn/SetValueDependsOnMapper";
import { AddValidationsDependsOnMapper } from "./DependsOn/AddValidationDependsOnMapper";
import { AbstractDependsOnMapper } from "./DependsOn/AbstractDependsOnMapper";
import { DefaultDependsOnMapper } from "./DependsOn/DefaultDependsOnMapper";

export class DependsOnMapper {
  mapperConfiguration: { [key in DependsOnThenEnum]: AbstractDependsOnMapper } = {
    [DependsOnThenEnum.Disable]: new DefaultDependsOnMapper(FormControlDependsOnThenEnum.Disable),
    [DependsOnThenEnum.Hide]: new DefaultDependsOnMapper(FormControlDependsOnThenEnum.Hide),
    [DependsOnThenEnum.IsRequired]: new DefaultDependsOnMapper(FormControlDependsOnThenEnum.IsRequired),
    [DependsOnThenEnum.SetValue]: new SetValueDependsOnMapper(),
    [DependsOnThenEnum.SetFocus]: new DefaultDependsOnMapper(FormControlDependsOnThenEnum.SetFocus),
    [DependsOnThenEnum.AddValidations]: new AddValidationsDependsOnMapper()
  };

  convert = (item: IDependsOn, fieldType: string): FormControlDependsOnSchema | undefined => {
    const mapper = this.mapperConfiguration[item.then];

    if (!mapper) {
      throw new Error("Then is not supported for this type of dependsOn");
    }

    return mapper.convert(item, fieldType);
  };

  convertNested = (item: INestedDependsOn, fieldType: string): FormControlDependsOnSchema | undefined => {
    const mapper = this.mapperConfiguration[item.then];

    if (!mapper) {
      throw new Error("Then is not supported for this type of dependsOn");
    }

    return mapper.convertNested(item, fieldType);
  };
}
